import React, { useContext, useState, useEffect } from "react";
import { LAText, LAView, LAWarningPopup } from "../../components";
import { IMAGES, SVG_IMAGES } from "../../assets";
import { useNavigate } from "react-router-dom";
import { STRINGS } from "../../constant";
import { AuthContext } from "../../context/AuthProvider";
import { GET_FLASHCARDS } from "../../api/content";
import { GET_FLASH_CARD_MENU } from "../../../app_constant";
import { BundleContext } from "../../context/BundleProvider";
import _ from "lodash";
import BackArrowIcon from "../../components/BackArrowIcon";
import { ThemeContext } from "../../context/ThemeProvider";
import BookMarkPopup from "../quickSet/BookMarkPopup";
import { MixpanelContext } from "../../context/MixpanelProvider";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBookmark, 
  faLayerGroup, 
  faRandom,
  faGraduationCap,
  faLock,
  faChevronUp,
  faChevronDown,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';

const FlashCards = () => {
  const { selectedCertificate } = useContext(BundleContext);
  const { profile } = useContext(AuthContext);
  const { trackFlashcardRecord, trackFlashcardBookmark } =
    useContext(MixpanelContext);

  const navigate = useNavigate();
  const [openItemId, setOpenItemId] = useState(3);
  const [subOpenItemId, setSubOpenItemId] = useState(null);
  const [flashCardTest, setFlashCardTest] = useState({
    isReset: true,
    testPopup: false,
  });
  const FLASHCARDS = GET_FLASHCARDS(selectedCertificate);
  const { theme, currentTheme } = useContext(ThemeContext);
  const [queCount, setQueCount] = useState();

  const FLASH_CARD_MENU = GET_FLASH_CARD_MENU(selectedCertificate);
  const selectedItems = [];
  const selectedIndex = (FLASH_CARD_MENU ?? []).findIndex(
    (e) => e.key == "by_topic"
  );
  selectedIndex >= 0 &&
    selectedItems.push(FLASH_CARD_MENU[selectedIndex].title);

  const selectedFreeIndex = (FLASH_CARD_MENU ?? []).findIndex(
    (e) => e.key == "by_topic_free_model"
  );
  selectedFreeIndex >= 0 &&
    selectedItems.push(FLASH_CARD_MENU[selectedFreeIndex].title);

  const [selectedMenu, setSelectedMenu] = useState(
    selectedIndex >= 0 ? selectedItems : []
  );
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedMainMenu, setSelectedMainMenu] = useState(null);
  const [isProgressQuestion, setProgressQuestion] = useState(false);
  const [isExamProgressQuestion, setExamProgressQuestion] = useState(false);

  const [selectedTopicBookmark, setSelectedTopicBookmark] = useState(null);
  const [isProgressBookmark, setProgressBookmark] = useState(false);

  const [isReset, setIsReset] = useState(true);

  // Card animations
  const cardVariants = {
    hover: { 
      scale: 1.02,
      boxShadow: "0px 8px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }
  };

  // Helper function to get icon background color
  const getIconBg = () => {
    return currentTheme === 'light' ? theme?.icon_bg?.flashcard_light : theme?.icon_bg?.flashcard_dark;
  }

  // Helper function to get card background
  const getCardBackground = (iconBg) => {
    const baseColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark;
    const darkerShade = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark;   
    return {
      background: `linear-gradient(to right, ${baseColor}, ${darkerShade})`,
      borderLeft: `4px solid ${iconBg || (currentTheme === 'light' ? theme?.icon_bg?.flashcard_light : theme?.icon_bg?.flashcard_dark)}`
    };
  };

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  // Helper function to get hover colors
  const getHoverColor = () => {
    return currentTheme === 'light'
      ? theme?.icon_bg?.flashcard_light
      : theme?.icon_bg?.flashcard_dark;
  };

  // Helper function to choose icon
  const getIcon = (item) => {
    if (item.key === "bookmark") return faBookmark;
    if (item.key === "by_topic" || item.key === "by_topic_free_model") return faLayerGroup;
    if (item.key === "exam") return faGraduationCap;
    if (item.key === "quick_set") return faRandom;
    return faLayerGroup;
  };

  function getQuestionCount(item) {
    const cards = FLASHCARDS.filter((e) => e.topic_id == item.id);
    return cards.length;
  }

  function onPressItem(item, index) {
    if (index == 0) {
      onPressBookmark(item);
    } else if (index == 1) {
      let cards = _.shuffle(FLASHCARDS);
      cards = cards.slice(0, 10);
      navigate("/flashcard/questions", {
        state: {
          cards: cards,
          set_id: "exam",
          title: item.title,
        },
      });
    } else if (item.key == "exam") {
      onPressExam(item);
    } else if (item.key == "all_cards") {
      onPressAll(item);
    } else {
      navigate("/flashcard/questions", {
        state: {
          cards: item,
          set_id: "exam",
          title: item.title,
        },
      });
    }
  }

  function onPressBookmark(item) {
    const progress = profile.flashcards_progress ?? [];
    const setProgress = progress.filter((obj) => {
      return obj.flashcard_set_id == "bookmark";
    });

    const array = profile?.flashcard_bookmarks ?? [];
    const cards = FLASHCARDS.filter((e) => array.includes(e?.id));

    if (
      setProgress &&
      setProgress.length > 0 &&
      cards.length > 0 &&
      cards[0]?.id != setProgress[0]?.last_seen_flashcard_id
    ) {
      setProgressBookmark(true);
    } else {
      navigate("/flashcard/questions", {
        state: {
          cards: cards,
          set_id: "bookmark",
          title: item.title,
        },
      });
    }
  }

  function onPressExam(item) {
    const progress = profile.flashcards_progress ?? [];
    const setProgress = progress.filter((obj) => {
      return obj.flashcard_set_id == "exam";
    });

    if (item?.topic_ids) {
      const cards = FLASHCARDS.filter((e) =>
        item.topic_ids.includes(e.topic_id)
      );
      if (
        setProgress &&
        setProgress.length > 0 &&
        cards[0]?.id != setProgress[0]?.last_seen_flashcard_id
      ) {
        setExamProgressQuestion(true);
      } else {
        navigate("/flashcard/questions", {
          state: {
            cards: cards,
            set_id: "exam",
            title: item.title,
          },
        });
      }
    } else {
      const cards = FLASHCARDS.filter((e) => e.type == "Exam Essentials");
      if (
        setProgress &&
        setProgress.length > 0 &&
        cards[0]?.id != setProgress[0]?.last_seen_flashcard_id
      ) {
        setExamProgressQuestion(true);
      } else {
        navigate("/flashcard/questions", {
          state: {
            cards: cards,
            set_id: "exam",
            title: item.title,
          },
        });
      }
    }
  }

  function onPressAll(item) {
    const progress = profile.flashcards_progress ?? [];
    const setProgress = progress.filter((obj) => {
      return obj.flashcard_set_id == 1 + 2;
    });

    if (item?.topic_ids) {
      const cards = FLASHCARDS.filter((e) =>
        item.topic_ids.includes(e.topic_id)
      );
      if (
        setProgress &&
        setProgress.length > 0 &&
        cards[0]?.id != setProgress[0]?.last_seen_flashcard_id
      ) {
        setProgressQuestion(true);
      } else {
        navigate("/flashcard/questions", {
          state: {
            cards: cards,
            set_id: 1 + 2,
            title: item.title,
          },
        });
      }
    } else {
      const cards = FLASHCARDS;
      if (
        setProgress &&
        setProgress.length > 0 &&
        cards[0]?.id != setProgress[0]?.last_seen_flashcard_id
      ) {
        setProgressQuestion(true);
      } else {
        navigate("/flashcard/questions", {
          state: {
            cards: cards,
            set_id: 1 + 2,
          },
        });
      }
    }
  }

  useEffect(() => {
    if (selectedTopic) {
      setProgressQuestion(true);
    }
  }, [selectedTopic]);

  useEffect(() => {
    if (selectedTopicBookmark) {
      setProgressBookmark(true);
    }
  }, [selectedTopicBookmark]);

  function SubElementChoose(item, ele) {
    
    const progress = profile.flashcards_progress ?? [];
    const setProgress = progress.filter((obj) => {
      return obj.flashcard_set_id == item.id + 2;
    });
    const cards = FLASHCARDS.filter((e) => e.topic_id == item.id);
    if (
      setProgress &&
      setProgress.length > 0 &&
      cards[0]?.id != setProgress[0]?.last_seen_flashcard_id
    ) {
      setSelectedTopic(item);
      setSelectedMainMenu(ele);
    } else {
      if (ele?.free_model == 1) {
        navigate("/flashcard/questions", {
          state: {
            cards: cards.slice(0, item.num_flashcards),
            set_id: item.id + 2,
            title: item.title,
          },
        });
      } else {
        navigate("/flashcard/questions", {
          state: {
            cards: cards,
            set_id: item.id + 2,
            title: item.title,
          },
        });
      }
    }
  }

  function onActionBookmark(index) {
    const progress = profile.flashcards_progress ?? [];
    const setProgress = progress.filter((obj) => {
      return obj.flashcard_set_id == "bookmark";
    });

    const item = FLASH_CARD_MENU.find((e) => e.key == "bookmark");

    const array = profile?.flashcard_bookmarks ?? [];
    const cards = FLASHCARDS.filter((e) => array.includes(e.id));

    if (index == 0) {
      navigate("/flashcard/questions", {
        state: {
          cards: cards,
          set_id: "bookmark",
          title: item.title,
        },
      });
    } else if (setProgress.length > 0) {
      if (item?.topic_ids) {
        const index = cards.findIndex(
          (obj) => obj.id == setProgress.last_seen_flashcard_id
        );

        navigate("/flashcard/questions", {
          state: {
            cards: cards,
            set_id: "bookmark",
            title: item.title,
            lastIndex: index == -1 ? 0 : index,
          },
        });
      } else if (index === 1) {
        const index = cards.findIndex(
          (obj) => obj.id == setProgress.last_seen_flashcard_id
        );

        navigate("/flashcard/questions", {
          state: {
            set_id: item.id + 2,
            cards: cards,
            set_id: "bookmark",
            title: item.title,
            lastIndex: index == -1 ? 0 : index,
          },
        });
      }
    } else {
      navigate("/flashcard/questions", {
        state: {
          cards: cards,
          set_id: "bookmark",
          title: item.title,
        },
      });
    }
  }

  function onActionExam(index) {
    const progress = profile.flashcards_progress ?? [];
    const setProgress = progress.filter((obj) => {
      return obj.flashcard_set_id == "exam";
    });

    const item = FLASH_CARD_MENU.find((e) => e.key == "exam");
    let cards = [];
    if (item?.topic_ids) {
      cards = FLASHCARDS.filter((e) => item.topic_ids.includes(e.topic_id));
    } else {
      cards = FLASHCARDS.filter((e) => e.type == "Exam Essentials");
    }

    if (index == 0) {
      navigate("/flashcard/questions", {
        state: {
          cards: cards,
          set_id: "exam",
          title: item.title,
        },
      });
    } else if (setProgress.length > 0) {
      if (item?.topic_ids) {
        const index = cards.findIndex(
          (obj) => obj.id == setProgress[0].last_seen_flashcard_id
        );
        navigate("/flashcard/questions", {
          state: {
            cards: cards,
            set_id: "exam",
            lastIndex: index == -1 ? 0 : index,
          },
        });
      } else {
        const index = cards.findIndex(
          (obj) => obj.id == setProgress[0].last_seen_flashcard_id
        );
        navigate("/flashcard/questions", {
          state: {
            set_id: item.id + 2,
            cards: cards,
            set_id: "exam",
            lastIndex: index == -1 ? 0 : index,
          },
        });
      }
    } else {
      navigate("/flashcard/questions", {
        state: {
          cards: cards,
          set_id: "exam",
          title: item.title,
        },
      });
    }
  }

  function onAction(index) {
    const item = selectedTopic;
    const menu = selectedMainMenu;
    if (index == 0 && item) {
      const cards = FLASHCARDS.filter((e) => e.topic_id === item.id);
      if (menu?.free_model == 1) {
        navigate("/flashcard/questions", {
          state: {
            set_id: item.id + 2,
            cards: cards.slice(0, item.num_flashcards),
          },
        });
      } else {
        navigate("/flashcard/questions", {
          state: {
            set_id: item.id + 2,
            cards: cards,
          },
        });
      }
    } else if (index == 0) {
      let cards = FLASHCARDS.filter((e) => e.topic_id === 100);
      cards = cards.length == 0 ? FLASHCARDS : cards;

      if (menu?.free_model == 1) {
        navigate("/flashcard/questions", {
          state: {
            set_id: 1 + 2,
            cards: cards.slice(0, item.num_flashcards),
          },
        });
      } else {
        navigate("/flashcard/questions", {
          state: {
            set_id: 1 + 2,
            cards: cards,
          },
        });
      }
    } else if (index == 1 && item) {
      const progress = profile.flashcards_progress;
      const setProgress = progress.filter(
        (obj) => obj.flashcard_set_id == item.id + 2
      );
      const cards = FLASHCARDS.filter((e) => e.topic_id == item.id);
      if (setProgress.length > 0) {
        const index = cards.findIndex(
          (obj) => obj.id == setProgress[0].last_seen_flashcard_id
        );

        if (menu?.free_model == 1) {
          navigate("/flashcard/questions", {
            state: {
              set_id: item.id + 2,
              cards: cards.slice(0, item.num_flashcards),
              lastIndex: index >= cards.length ? 0 : index == -1 ? 0 : index,
            },
          });
        } else {
          navigate("/flashcard/questions", {
            state: {
              set_id: item.id + 2,
              cards: cards,
              lastIndex: index == -1 ? 0 : index,
            },
          });
        }
      }
    } else if (index == 1) {
      const progress = profile.flashcards_progress;
      const setProgress = progress.filter(
        (obj) => obj.flashcard_set_id == 1 + 2
      );
      let cards = FLASHCARDS.filter((e) => e.topic_id == 100);
      cards = cards.length == 0 ? FLASHCARDS : cards;
      if (setProgress.length > 0) {
        const index = cards.findIndex(
          (obj) => obj.id == setProgress[0].last_seen_flashcard_id
        );

        if (menu?.free_model == 1) {
          navigate("/flashcard/questions", {
            state: {
              set_id: 1 + 2,
              cards: cards.slice(0, item.num_flashcards),
              lastIndex: index >= cards.length ? 0 : index == -1 ? 0 : index,
            },
          });
        } else {
          navigate("/flashcard/questions", {
            state: {
              set_id: 1 + 2,
              cards: cards,
              lastIndex: index == -1 ? 0 : index,
            },
          });
        }
      }
    }
  }

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center mb-6">
        <button
          className="rounded-lg border-2 p-2 mr-4 flex items-center justify-center"
          style={{ borderColor: currentTheme === "light" ? theme?.border_color?.light : theme?.border_color?.dark }}
          onClick={() => navigate("/home")}
        >
          <BackArrowIcon
            color={currentTheme === "light" ? theme?.text?.light : theme?.text?.dark}
          />
        </button>
        <h1 
          className="text-2xl font-semibold"
          style={{ color: getTextColor() }}
        >
          Flashcards
        </h1>
      </div>

      {/* Categories Section */}
      <div className="grid grid-cols-1 gap-4 mb-8">
        {FLASH_CARD_MENU?.map((ele, idx) => {
          const isSelected = selectedMenu.includes(ele.title);
          
          

          const iconBg = getIconBg();

          // For locked premium items
          

          return (
            <motion.div
              key={idx + 1}
              className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
              whileHover="hover"
              variants={cardVariants}
            >
              <div 
                className="cursor-pointer"
                style={getCardBackground(iconBg)}
              >
                <div 
                  className="p-4"
                  onClick={() => {
                    if (ele?.menu) {
                      if (isSelected) {
                        let selected = [...selectedMenu];
                        selected = selected.filter(
                          (menu) => menu != ele?.title
                        );
                        setSelectedMenu(selected);
                      } else {
                        let selected = [...selectedMenu];
                        selected.push(ele?.title);
                        setSelectedMenu(selected);
                      }
                    } else {
                      onPressItem(ele, idx);
                    }
                  }}
                >
                  <div className="flex items-center">
                    <div 
                      className="w-12 h-12 rounded-full flex items-center justify-center mr-4"
                      style={{ backgroundColor: iconBg }}
                    >
                      <FontAwesomeIcon 
                        icon={getIcon(ele)} 
                        className="text-white text-xl" 
                      />
                    </div>
                    <div className="flex-1">
                      <h2 
                        className="text-lg font-medium"
                        style={{ color: getTextColor() }}
                      >
                        {ele?.title}
                      </h2>
                    </div>
                    {ele?.menu && (
                      <div className="ml-2">
                        <FontAwesomeIcon 
                          icon={isSelected ? faChevronUp : faChevronDown} 
                          style={{ color: getTextColor() }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Sub-items section */}
                {isSelected && ele?.menu && (
                  <div className="border-t border-gray-200 dark:border-gray-600">
                    {ele?.menu?.map((subElement, idx) => {
                      const no_of_que = getQuestionCount(subElement);
                      
                      
                      return (
                        <div 
                          key={subElement?.id + 4}
                          className="p-4 border-b border-gray-100 dark:border-gray-700 hover:bg-opacity-50 cursor-pointer hover:bg-gray-500 dark:hover:bg-gray-500"
                          onClick={() => { SubElementChoose(subElement, ele); }}
                        >
                          <div className="flex items-center justify-between">
                            <div>
                              <h3 
                                className="text-base font-medium"
                                style={{ color: getTextColor() }}
                              >
                                {subElement?.domain_name}
                              </h3>
                              {subElement?.content && (
                                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                  {subElement?.content}
                                </p>
                              )}
                            </div>
                            <div className="flex items-center">
                              <span 
                                className="text-sm px-3 py-1 rounded-full mr-2"
                                style={{ 
                                  backgroundColor: currentTheme === 'light' 
                                    ? 'rgba(0,0,0,0.1)' 
                                    : 'rgba(255,255,255,0.1)',
                                  color: getTextColor()
                                }}
                              >
                                {ele?.free_model == 1 && subElement?.num_flashcards
                                  ? subElement?.num_flashcards
                                  : no_of_que} Cards
                              </span>
                              
                              
                                <FontAwesomeIcon 
                                  icon={faChevronRight} 
                                  style={{ color: getTextColor() }}
                                />
                              
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* Popups */}
      {isProgressQuestion && (
        <BookMarkPopup
          title={`${STRINGS.flashcards}`}
          message={STRINGS.flashcard_message}
          cancelText={STRINGS?.cancel}
          options={[STRINGS.start_from_beginning, STRINGS.resume_from_stopped]}
          onCancel={() => {
            setProgressQuestion(false);
          }}
          onPressOptions={async (index) => {
            if (index === 0) {
              setSelectedTopicBookmark(null);
              onAction(index);
            } else if (index === 1) {
              setSelectedTopicBookmark(null);
              onAction(index);
            }
            setProgressQuestion(false);
          }}
        />
      )}
      
      {isExamProgressQuestion && (
        <BookMarkPopup
          title={STRINGS.flashcard}
          message={STRINGS.flashcard_message}
          cancelText={STRINGS?.cancel}
          options={[STRINGS.start_from_beginning, STRINGS.resume_from_stopped]}
          onCancel={() => {
            setExamProgressQuestion(false);
          }}
          onPressOptions={async (index) => {
            setExamProgressQuestion(false);
            if (index === 0) {
              setSelectedTopicBookmark(null);
              onActionExam(index);
            } else if (index === 1) {
              setSelectedTopicBookmark(null);
              onActionExam(index);
            }
          }}
        />
      )}
      
      {isProgressBookmark && (
        <BookMarkPopup
          title={STRINGS.study_questions}
          message={STRINGS.flashcard_message}
          cancelText={STRINGS?.cancel}
          options={[STRINGS.start_from_beginning, STRINGS.resume_from_stopped]}
          onCancel={() => {
            setProgressBookmark(false);
          }}
          onPressOptions={async (index) => {
            setProgressBookmark(false);
            if (index === 0) {
              setSelectedTopicBookmark(null);
              onActionBookmark(index);
            } else if (index === 1) {
              setSelectedTopicBookmark(null);
              onActionBookmark(index);
            }
          }}
        />
      )}
    </div>
  );
};

export default FlashCards;